/**
 * `approvals` namespace — English canonical source.
 *
 * The approvals inbox (routes/approvals.tsx): page chrome, the live countdown and
 * its duration units, the timeout-behavior line, the high-value note, the token
 * form (label/placeholder/hint), and the Approve/Reject actions. Per the glossary
 * Approve→승인, Reject→거부, Expired→만료됨. The neutral Cancel action reuses
 * `common.cancel`. `ko/approvals.ts` mirrors this shape (a missing key is a type
 * error).
 */
export const approvals = {
  // ── page chrome ──
  eyebrow: "Human-in-the-loop",
  title: "Approvals",
  description: "Orders awaiting your decision, each with its deadline and timeout behavior.",

  // ── empty / error ──
  loadError: "Could not load approvals. Try again.",
  emptyTitle: "No pending approvals",
  emptyDescription:
    "When an approval-required strategy proposes a trade, it appears here (and as a push).",

  // ── countdown ──
  expired: "Expired",
  timeLeft: "{time} left",
  durationHm: "{h}h {m}m",
  durationMs: "{m}m {s}s",
  durationS: "{s}s",

  // ── timeout behavior ──
  onTimeoutLabel: "On timeout:",
  autoApprove: "auto-approve",
  cancelTimeout: "cancel",

  // ── high-value guard ──
  highValueNote: "High-value order — routed through approval regardless of mode (§4.4).",

  // ── token form ──
  tokenLabel: "Approval token",
  tokenPlaceholder: "Paste the token from your notification",
  tokenHint: "The single-use token from the approval push / notification.",
  confirmApprove: "Confirm approve",

  // ── actions ──
  approve: "Approve…",
  reject: "Reject",

  // ── action errors ──
  tokenRejected: "That token was not accepted. Check it and try again.",
  rejectError: "Could not reject. Try again.",

  // ── order intent summary ──
  shares: "{qty} sh",
  sideBuy: "BUY",
  sideSell: "SELL",
  typeMarket: "MARKET",
  typeLimit: "LIMIT",
} as const;

export type ApprovalsKey = keyof typeof approvals;
